(function ($) {
  'use strict';

  var initbackToTop = function () {
    var $backBtn = $('.back-to-top-btn');
    var $component = $('.cc--back-to-top');

    $(window).scroll(function () {
      if ($(this).scrollTop() >= 300) {
        $component.fadeIn(200);
      }
      else {
        $component.fadeOut(200);
      }
    });

    $backBtn.click(function () {
      $('body,html').animate({
        scrollTop: 0
      }, 500);
    });
  };

  /**
  * This is boilerplate: add a behavior to window.DP.behaviors
  */
  window.DP.behaviors.backToTop = {
    attach: function (context) {
      once('backToTop', '.cc--back-to-top', context)
        .forEach((e) => {
          initbackToTop.apply(e);
        });
      // $(context).find('.cc--back-to-top').once('backToTop').each(function () {
      //   initbackToTop.apply(this);
      // });
    }
  };

})(jQuery);
